<!-- @format -->

<template>
	<!-- Mismo control de "carpetas" que el gestor de certplag: el año y los meses
	     son una sola barra apoyada sobre la línea que es el borde de la tabla. -->
	<div class="selector-mes-tabs">
		<div class="selector-mes-tabs__barra">
			<div class="selector-mes-tabs__grupo">
				<v-select
					:value="anio"
					:items="listaAnios"
					:disabled="cargando"
					solo
					flat
					dense
					hide-details
					:menu-props="{ offsetY: true }"
					class="selector-mes-tabs__anio"
					@change="cambiarAnio"
				/>
				<v-tabs
					:value="indiceMes"
					show-arrows
					center-active
					background-color="transparent"
					color="primary"
					height="30"
					class="folder-tabs"
					@change="cambiarMes"
				>
					<v-tab
						v-for="mes in meses"
						:key="mes.valor"
						:disabled="cargando"
						:class="{ 'folder-tabs__sin-datos': sinDatos(mes) }"
						style="border-radius: 20px 20px 0px 0px; height: 30px"
					>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<span class="folder-tabs__etiqueta" v-bind="attrs" v-on="on">
									{{ mes.texto }}
								</span>
							</template>
							<span class="folder-tabs__globo">{{ textoConteo(mes) }}</span>
						</v-tooltip>
					</v-tab>
				</v-tabs>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'WorkOrderMonthTabs',
	props: {
		valor: { type: String, default: '' }, // 'YYYY-MM'
		conteos: { type: Object, default: () => ({}) },
		cargando: { type: Boolean, default: false },
		aniosAtras: { type: Number, default: 4 },
	},
	data() {
		return { anio: Number((this.valor || moment().format('YYYY-MM')).slice(0, 4)) };
	},
	computed: {
		anioActual() {
			return Number(moment().format('YYYY'));
		},
		listaAnios() {
			return Array.from(
				{ length: this.aniosAtras + 1 },
				(item, indice) => this.anioActual - indice
			);
		},
		meses() {
			return Array.from({ length: 12 }, (item, indice) => {
				const fecha = moment(
					`${this.anio}-${String(indice + 1).padStart(2, '0')}`,
					'YYYY-MM'
				);
				return { valor: fecha.format('YYYY-MM'), texto: fecha.format('MMM') };
			});
		},
		indiceMes() {
			return this.meses.findIndex(mes => mes.valor === this.valor);
		},
	},
	watch: {
		valor(nuevo) {
			if (nuevo) this.anio = Number(nuevo.slice(0, 4));
		},
	},
	methods: {
		sinDatos(mes) {
			return !this.conteos[mes.valor] && mes.valor !== this.valor;
		},
		textoConteo(mes) {
			const cantidad = this.conteos[mes.valor];
			if (cantidad === undefined) return 'Sin información cargada';
			if (!cantidad) return 'Sin órdenes';
			return `${cantidad} orden${cantidad === 1 ? '' : 'es'}`;
		},
		cambiarMes(indice) {
			const mes = this.meses[indice];
			if (mes && mes.valor !== this.valor) this.$emit('input', mes.valor);
		},
		cambiarAnio(anio) {
			this.anio = Number(anio);
			this.$emit('anio', String(anio));
		},
	},
};
</script>

<style lang="scss" scoped>
/* El año y los meses son UNA sola barra: misma altura y misma línea base,
   apoyados sobre la línea de la carpeta. */
.selector-mes-tabs {
	width: 100%;
}

.selector-mes-tabs__barra {
	display: flex;
	justify-content: stretch;
	flex-wrap: nowrap;
	min-width: 0;
}

.selector-mes-tabs__grupo {
	display: flex;
	align-items: flex-end;
	flex: 1 1 100%;
	width: 100%;
	min-width: 0;
	max-width: 100%;
	border-bottom: none;
}

/* Selector de año con la misma pinta de pestaña que los meses */
.selector-mes-tabs__anio {
	flex: 0 0 auto;
	width: 92px;
	margin-right: 8px;
}

.selector-mes-tabs__anio ::v-deep .v-input__control,
.selector-mes-tabs__anio ::v-deep .v-input__slot {
	min-height: 30px !important;
	height: 30px;
}

.selector-mes-tabs__anio ::v-deep .v-input__slot {
	padding: 0 8px !important;
	border-radius: 8px 8px 0 0 !important;
	background-color: #eceff1 !important;
	box-shadow: none !important;
}

.selector-mes-tabs__anio ::v-deep .v-select__selections {
	flex-wrap: nowrap;
}

.selector-mes-tabs__anio ::v-deep .v-select__selection {
	font-size: 13px;
	font-weight: 700;
	color: #37474f;
}

.selector-mes-tabs__anio ::v-deep .v-input__append-inner {
	margin-top: 3px;
	padding-left: 0;
}

.selector-mes-tabs__anio ::v-deep .v-input__icon .v-icon {
	font-size: 18px;
}

.folder-tabs {
	margin-bottom: 0;
	min-width: 0;
	flex: 1 1 auto;
	width: 100%;
	max-width: none;
}

.folder-tabs ::v-deep .v-slide-group__wrapper,
.folder-tabs ::v-deep .v-slide-group__content {
	width: 100%;
}

.folder-tabs ::v-deep .v-tabs-bar {
	background-color: transparent;
}

.folder-tabs ::v-deep .v-tab {
	flex: 1 1 0;
	border-radius: 8px 8px 0 0;
	border: 1px solid transparent;
	border-bottom: none;
	margin-right: 4px;
	min-width: 56px;
	max-width: none;
	padding: 0 12px;
	font-size: 13px;
	font-weight: 600;
	background-color: #f5f5f5;
	transition: all 0.2s ease;
}

.folder-tabs ::v-deep .v-tab:last-child {
	margin-right: 0;
}

.folder-tabs ::v-deep .v-tab--active {
	background-color: #e3f2fd; /* azul claro: señala el mes seleccionado */
	border-color: #90caf9;
	border-bottom-color: #e3f2fd;
	color: #1565c0 !important;
	position: relative;
	top: 1px;
	font-weight: bold;
	z-index: 2;
}

.folder-tabs ::v-deep .v-tab:not(.v-tab--active):hover {
	background-color: #eeeeee;
}

/* La etiqueta llena la pestaña para que el globo salga al pasar por cualquier
   parte del mes, no solo sobre las letras */
.folder-tabs__etiqueta {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
}

.folder-tabs__globo {
	font-size: 13px;
	font-weight: 600;
}

/* Meses sin información: se ven, pero apagados */
.folder-tabs ::v-deep .v-tab.folder-tabs__sin-datos:not(.v-tab--active) {
	background-color: #fafafa;
	color: #607d8b;
}

/* En celular la tira de meses se arrastra con el dedo */
@media (max-width: 599px) {
	.selector-mes-tabs__anio {
		width: 86px;
		margin-right: 6px;
	}

	.folder-tabs ::v-deep .v-tab {
		flex: 0 0 auto;
		min-width: 46px;
		padding: 0 8px;
		margin-right: 3px;
	}
}
</style>
